import request from '@/utils/request'

export function getMenuMapping() {
  return request({
    url: '/api/home/sys/mapping/getmenumapping',
    method: 'get'
  })
}

// export function getStationMapping() {
//   return request({
//     url: '/api/home/mapping/getstationmapping',
//     method: 'get'
//   })
// }


// WEBPACK FOOTER //
// ./src/api/mapping.js